<template>
  <div class="rtl">
    <user-tabs></user-tabs>
    <m-form
      title="کاربران"
      :apiUrl="baseUrl"
      :serverProcessing="true"
      :cols="cols"
      :isEditing.sync="isEditing"
      :canDelete="canDelete"
      :canSubmit="canSubmit"
      :show-navigation-btns="false"
      :showListBtn="false"
      :showListExportBtn="false"
      :list_filters="filters"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="submit"
      @delete="deleteItem"
    >
      <template #default>
        <v-row>
          <v-col cols="12" md="12">
            <user-info :user-info="item" />
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-tabs v-model="tab" grow>
            <v-tab key="companies">شرکت ها</v-tab>
            <v-tab key="wallet">کیف پول</v-tab>
          </v-tabs>

          <v-col cols="12" md="12">
            <v-tabs-items v-model="tab" :reverse="true">
              <v-tab-item key="companies">
                <user-companies :companies="item.companies" />
              </v-tab-item>
              <v-tab-item key="wallet">
                <user-wallet :user-id="item.id" :balance="item.balance"></user-wallet>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </template>
      <template #footer-btns>
        <v-btn
          :disabled="!isEditing"
          v-if="item.id && hasPerm('changePassword', 'user', item)"
          @click="showChangePasswordDialog = true"
          class="info rounded-lg white--text mr-1"
          depressed
        >
          تغیر کلمه عبور
        </v-btn>
      </template>

      <template #title-left>
        <v-text-field label="نام کاربری" v-model="filters.username__startswith" class="rounded-lg" />
      </template>
    </m-form>

    <v-dialog v-model="showChangePasswordDialog" max-width="500px">
      <v-card>
        <v-card-title>تغیر کلمه عبور</v-card-title>
        <v-card-text>
          <v-text-field label="کلمه عبور جدید" v-model="newPassword" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="changePassword" class="w-100px green white--text">ثبت</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import MFormMixin from "@/components/m-form/MForm.js";
import UserTabs from "@/views/panel/UserTabs";
import UserCompanies from "@/components/users/UserCompanies.vue";
import UserWallet from "@/components/users/UserWallet.vue";
import UserInfo from "@/components/users/UserInfo.vue";

export default {
  components: { UserTabs, UserCompanies, UserWallet, UserInfo },
  mixins: [MFormMixin],
  props: {},
  data() {
    return {
      baseUrl: "sobhanAdmin/users/",
      leadingSlash: false,
      items: [],
      newPassword: "",
      showChangePasswordDialog: false,
      permissionBasename: "user",
      cols: [
        {
          text: "نام",
          value: "first_name",
          type: "text",
          filters: ["first_name"],
        },
        {
          text: "نام خانوادگی",
          value: "last_name",
          type: "text",
          filters: ["last_name"],
        },
        {
          text: "نام کاربری",
          value: "username",
          type: "text",
          filters: ["username"],
        },
      ],
      filters: {},
      tab: null,
    };
  },
  computed: {},
  created() {
    this.item = this.getItemTemplate();
  },
  methods: {
    setItem(item) {
      this.request({
        url: this.endpoint(`sobhanAdmin/users/${item.id}/`),
        method: "get",
        success: (data) => {
          console.log(data);
          this.item = data;
        },
      });
    },
    getItemTemplate() {
      return {};
    },
    changePassword() {
      this.request({
        url: this.endpoint(`users/changePassword`),
        method: "post",
        data: {
          user: this.item.id,
          password: this.newPassword,
        },
        success: (data) => {
          this.newPassword = "";
          this.successNotify();
          this.showChangePasswordDialog = false;
        },
      });
    },
  },
};
</script>
